import { render, staticRenderFns } from "./BlockUnblock.vue?vue&type=template&id=e54e5922&"
import script from "./BlockUnblock.vue?vue&type=script&lang=js&"
export * from "./BlockUnblock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports